import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { getFingerprint } from '@telecom/shared/utils/fingerprint';
import { isUserLogin } from '@telecom/shared/startup/user-auth';
import { OnboardingBrowserRuntimeImpl } from '../../common/services/impls/onboarding-browser-runtime';
import type { NoveltySearchOnboardingRuntime } from '../novelty-search-onboarding-runtime';

/**
 * 查新首页首次引导的浏览器运行时。
 *
 * 统一封装身份、登录态、存储、Driver、DOM 查询和定时器能力，
 * 避免业务 service 直接依赖具体浏览器 API。
 */
@injectable()
export class NoveltySearchOnboardingRuntimeImpl
    extends OnboardingBrowserRuntimeImpl
    implements NoveltySearchOnboardingRuntime {
    /** 获取用于隔离首次展示状态的浏览器稳定指纹。 */
    getIdentityId(): Promise<string> {
        return getFingerprint();
    }

    /** 查询当前用户登录状态。 */
    isUserLogin(): Promise<boolean> {
        return isUserLogin();
    }
}
